export default function LegalTerms() {
  return (
    <section id="terms" className="legal-section">
      <h2 className="legal-section-title">Terms &amp; Conditions</h2>
      <p className="legal-meta">Last Updated: {new Date().toISOString().slice(0, 10)}</p>

      <h3>1. Introduction</h3>
      <p>
        Welcome to Pista, a board game companion app operated by VoyagerBug (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; or
        &quot;our&quot;). By downloading, accessing, or using Pista (the &quot;App&quot;), you agree to be bound by these
        Terms &amp; Conditions (the &quot;Terms&quot;). If you do not agree to these Terms, do not use the App.
      </p>
      <p>
        These Terms apply to all users of the App, including users who are also contributors of
        content.
      </p>

      <h3>2. Eligibility</h3>
      <p>
        You must be at least 13 years old to use the App. By using the App, you represent and warrant
        that you meet this age requirement.
      </p>

      <h3>3. Account Registration</h3>
      <ul>
        <li>You may be required to create an account to access certain features.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>You are responsible for all activity that occurs under your account.</li>
        <li>You agree to provide accurate and complete information during registration.</li>
        <li>You must verify your email address to access certain features.</li>
      </ul>

      <h3>4. Subscription &amp; Payment</h3>
      <ul>
        <li>
          <strong>Free Tier:</strong> The App currently offers a free tier with limited features.
        </li>
        <li>
          <strong>Paid Tier:</strong> We may offer additional features through a paid subscription.
          Subscription fees, billing cycles, and cancellation policies will be clearly stated at the
          point of purchase.
        </li>
        <li>
          <strong>Auto-Renewal:</strong> Paid subscriptions will automatically renew unless cancelled
          before the renewal date. You can cancel at any time through your account settings.
        </li>
        <li>
          <strong>Refunds:</strong> Refunds for subscription fees are handled on a case-by-case basis.
          Please contact support for assistance.
        </li>
      </ul>

      <h3>5. User Conduct</h3>
      <p>You agree not to use the App to:</p>
      <ul>
        <li>Violate any applicable laws or regulations.</li>
        <li>Infringe on the intellectual property rights of others.</li>
        <li>Transmit any harmful, offensive, or illegal content.</li>
        <li>Attempt to gain unauthorized access to the App or its systems.</li>
        <li>Interfere with the operation of the App.</li>
        <li>Use the App for any commercial purpose without our prior written consent.</li>
      </ul>

      <h3>6. Intellectual Property</h3>
      <ul>
        <li>
          <strong>Our IP:</strong> The App, its design, features, content (excluding user data),
          logos, and trademarks are the property of VoyagerBug. You may not copy, modify, distribute,
          or reverse engineer any part of the App without our express permission.
        </li>
        <li>
          <strong>User Content:</strong> By using the App, you may upload or generate content (e.g.,
          your game collection, play logs, ratings). You retain ownership of your user content. By
          submitting content to the App, you grant us a non-exclusive, royalty-free, worldwide license
          to use, store, and display that content for the purpose of operating and improving the App.
        </li>
      </ul>

      <h3>7. Third-Party Services</h3>
      <p>
        The App integrates with third-party services, including BoardGameGeek (BGG) and Board Game
        Arena (BGA). Your use of these services is subject to their respective terms and conditions.
        We are not responsible for the content or practices of these third parties.
      </p>

      <h3>8. Data Collection &amp; Privacy</h3>
      <p>
        Our collection and use of personal data is governed by our{" "}
        <a href="#privacy">Privacy Policy</a>, which is incorporated into these Terms by reference.
        By using the App, you consent to our data practices as described therein.
      </p>

      <h3>9. Disclaimers</h3>
      <ul>
        <li>
          The App is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, either
          express or implied.
        </li>
        <li>
          We do not warrant that the App will be uninterrupted, error-free, or free from viruses or
          other harmful components.
        </li>
        <li>
          Board game data is sourced from third parties. We do not guarantee the accuracy or
          completeness of such data.
        </li>
      </ul>

      <h3>10. Limitation of Liability</h3>
      <p>
        To the fullest extent permitted by law, VoyagerBug shall not be liable for any indirect,
        incidental, special, consequential, or punitive damages arising from or related to your use of
        the App, even if advised of the possibility of such damages. Our total liability shall not
        exceed the amount you paid, if any, to use the App in the twelve (12) months preceding the
        claim.
      </p>

      <h3>11. Termination</h3>
      <p>
        We may suspend or terminate your account at any time, with or without notice, if we believe
        you have violated these Terms or applicable law. You may also delete your account at any time
        through the App settings.
      </p>
      <p>
        Upon termination, your right to use the App will immediately cease. Provisions that by their
        nature should survive termination will survive.
      </p>

      <h3>12. Governing Law &amp; Dispute Resolution</h3>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the United
        Kingdom. Any dispute arising from these Terms shall be resolved through binding arbitration
        or in the courts of the United Kingdom.
      </p>

      <h3>13. Changes to Terms</h3>
      <p>
        We may update these Terms from time to time. We will notify you of material changes via email
        or through the App. Continued use of the App after changes become effective constitutes your
        acceptance of the revised Terms.
      </p>

      <h3>14. Contact Us</h3>
      <p>
        For questions about these Terms, please contact us at{" "}
        <a href="mailto:threads@voyagerbug.com">threads@voyagerbug.com</a>.
      </p>
    </section>
  );
}
